import { render, staticRenderFns } from "./TitleMonth.vue?vue&type=template&id=2988ad49&scoped=true&"
import script from "./TitleMonth.vue?vue&type=script&lang=js&"
export * from "./TitleMonth.vue?vue&type=script&lang=js&"
import style0 from "./TitleMonth.vue?vue&type=style&index=0&id=2988ad49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2988ad49",
  null
  
)

export default component.exports